import Vue from "vue";
import Router from "vue-router";

const Home = () => import("@/pages/home/Home");

const ComprehensiveMap = () => import("@/pages/comprehensive_map/ComprehensiveMap");
const PatrolRecord = () => import("@/pages/patrol_record/PatrolRecord");
const HistoryTrend = () => import("@/pages/history_trend/HistoryTrend");
const AlarmList = () => import("@/pages/alarm_list/AlarmList");
const AlarmRule = () => import("@/pages/alarm_rule/AlarmRule");
const TaskList = () => import("@/pages/task_list/TaskList");
const DeviceManage = () => import("@/pages/manage/device_manage/DeviceManage");
const EditGroup = () => import("@/pages/manage/device_manage/modules/EditGroup");
const EditStation = () => import("@/pages/manage/device_manage/modules/EditStation");
const EditProject = () => import("@/pages/manage/device_manage/modules/EditProject");
const PeopleManage = () => import("@/pages/manage/people_manage/PeopleManage");
const PollutionManage = () => import("@/pages/manage/pollution_manage/PollutionManage");
const PatrolRouteManage = () => import("@/pages/manage/patrol_route_manage/PatrolRouteManage");

Vue.use(Router);

// hack router push callback
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

// hack router replace callback
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const router = new Router({
  routes: [
    {
      path: "*",
      name: "Home",
      component: Home
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      redirect: "/ComprehensiveMap",
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: "/ComprehensiveMap",
          name: "ComprehensiveMap",
          component: ComprehensiveMap,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/PatrolRecord",
          name: "PatrolRecord",
          component: PatrolRecord,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/HistoryTrend",
          name: "HistoryTrend",
          component: HistoryTrend,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/AlarmList",
          name: "AlarmList",
          component: AlarmList,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/AlarmRule",
          name: "AlarmRule",
          component: AlarmRule,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/TaskList",
          name: "TaskList",
          component: TaskList,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/PeopleManage",
          name: "PeopleManage",
          component: PeopleManage,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/PollutionManage",
          name: "PollutionManage",
          component: PollutionManage,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/PatrolRouteManage",
          name: "PatrolRouteManage",
          component: PatrolRouteManage,
          meta: {
            requireAuth: true,
            requirePermission: true
          }
        },
        {
          path: "/DeviceManage",
          name: "DeviceManage",
          component: DeviceManage,
          meta: {
            requireAuth: true,
            requirePermission: true
          },
          children: [
            {
              path: "EditGroup/:id",
              name: "EditGroup",
              component: EditGroup,
              meta: {
                requireAuth: true,
                requirePermission: true
              }
            },
            {
              path: "EditProject/:id",
              name: "EditProject",
              component: EditProject,
              meta: {
                requireAuth: true,
                requirePermission: true
              }
            },
            {
              path: "EditStation/:id",
              name: "EditStation",
              component: EditStation,
              meta: {
                requireAuth: true,
                requirePermission: true
              }
            }
          ]
        }
      ]
    }
  ]
});

export default router;
